/*!
 * The Guesthouse
 *
 * @copyright     Copyright 2014-2020 codeQ e.U. and Code Q Web Factory GmbH
 * @link          http://codeq.at
 * @author        Roland Schuetz <rs@codeq.at>
 */
"use strict";

// libraries
import 'lazysizes';
import 'jquery';
import '../jquery-ui-custom/jquery-ui-1.12.1.custom.min.js';
import 'cookieconsent';

// theme
import './polyfills.js';

// Components
import '../../../../Private/Fusion/Component/FullscreenImage/FullscreenImage.js';
import '../../../../Private/Fusion/Component/Gallery/Gallery.js';
import '../../../../Private/Fusion/Component/ImageSlider/ImageSlider.js';
import '../../../../Private/Fusion/Component/ScrollButtons/ScrollButtons.js';
import '../../../../Private/Fusion/Component/SquareTeaser/SquareTeaser.js';
import '../../../../Private/Fusion/Component/SquareTeaser/SquareTeaser.Slider.js';

// Content NodeTypes
import '../../../../Private/Fusion/Content/Form/Form.js';
import '../../../../Private/Fusion/Content/LocalNavigation/LocalNavigation.js';
import '../../../../Private/Fusion/Content/Map/Map.js';
import '../../../../Private/Fusion/Component/NewsTeaser/NewsTeaser.js';

import scrollTo from './scroll-to.js';
import YoutubePlayer from "./youtube-player";

jQuery(function ($) {
    // smooth scrolling
    // http://css-tricks.com/snippets/jquery/smooth-scrolling/
    $('a[href*="#"]:not([href="#"])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            || location.hostname == this.hostname) {
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                scrollTo(target);
                return false;
            }
        }
    });

    // if there is a hash on load, scroll there
    // (IE doesn't do this, the animated scrolling is nice as well)
    if (window.location.hash) {
        scrollTo($(window.location.hash));
    }
});

(function () {
    // mobile menu
    let menuIsOpen = false;
    let body = document.querySelector('body');
    const wrapper = document.getElementById('wrapper');
    const menuButton = document.querySelector('.menu-button');
    const navigation = document.querySelector('.mod_navigation');

    if (menuButton) {
        menuButton.addEventListener('click', () => {
            body.classList[!menuIsOpen ? 'add' : 'remove']('is-menu-open');
            navigation.ariaExpanded = !menuIsOpen;
            menuIsOpen = !menuIsOpen;

            if (body.classList.contains('is-menu-open')) {
                body.style.top = '-' + document.documentElement.style.getPropertyValue('--scroll-y');
                // open the currently active menu
                const activeFirstLevelItem = document.querySelector('.mod_navigation > ul > li.active');
                if (activeFirstLevelItem) {
                    openSubMenu(activeFirstLevelItem);
                }
            } else {
                window.scrollTo(0, parseInt(body.style.top || '0') * -1);
                body.style.top = 'auto';
            }
        });
    }

    body.classList[window.scrollY > 5 ? 'add' : 'remove']('is-scrolled');
    window.addEventListener('scroll', () => {
        body.classList[window.scrollY > 5 ? 'add' : 'remove']('is-scrolled');
        document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    })

    document.querySelectorAll('.mod_navigation .caret').forEach(el => {
        let parentLi = el.parentElement;
        if (parentLi.querySelector('.navigation-level-2')) {
            el.addEventListener('click', (e) => {
                openSubMenu(e.target.parentElement);
            });
        }
    });

    const openSubMenu = (liElement) => {
        if (window.innerWidth >= 768) {
            return;
        }

        let getSiblings = n => [...n.parentElement.children].filter(c => c != n);
        let siblingsLi = getSiblings(liElement);

        siblingsLi.forEach(_el => {
            _el.classList.remove('is-submenu-open');
        });

        liElement.classList.toggle('is-submenu-open');
    }

    YoutubePlayer.init();

    // high contrast trigger behavior
    let highContrastTrigger = document.querySelector('.high-contrast__trigger');
    let isHighContrastEnabled = window.localStorage.getItem('high-contrast') === 'true';
    let teaser = $('.ce_rsce_news_teaser'); // homepage small teaser

    if (isHighContrastEnabled) highContrastTrigger.checked = true;
    window.localStorage.setItem('high-contrast', highContrastTrigger.checked);
    body.classList[highContrastTrigger.checked ? 'add' : 'remove']('is-high-contrast');

    window.addEventListener('change', (e) => {
        if (e.target.isSameNode(highContrastTrigger)) {
            window.localStorage.setItem('high-contrast', e.target.checked);
                body.classList[e.target.checked ? 'add' : 'remove']('is-high-contrast');

            if (!e.target.checked && teaser.length) {
                setTimeout(function () {
                    if (document.querySelector('body.neos-backend')) {
                        return; // in the backend allow editing
                    }
                    teaser.addClass('closed');
                }, 4000);
            } else {
                teaser.removeClass('closed');
            }
        }
    });
})();
